import { createAction } from "redux-actions";
import { GET_CONSOLIDATE, UPDATE_ALIAS_CONSOLIDATE } from "../constants";
import { feathersCreateData } from "./../services";


export const getConsolidateUser = createAction(GET_CONSOLIDATE, (data) => feathersCreateData('core-server',{
    service: 'CONSOLIDATED',
    func: 'RETURN CONSOLIDATE OF PRODUCTS',
    data
})())

export const changeAliasAccount = createAction(UPDATE_ALIAS_CONSOLIDATE, (dataAccount) => dataAccount)